export class FirebaseLiveError extends Error {
  readonly code: string;

  constructor(code: string, message: string) {
    super(message);
    this.name = "FirebaseLiveError";
    this.code = code;
  }
}

/** Read a Firebase SDK error code (`auth/...`, `permission-denied`, ...). */
export function firebaseErrorCode(error: unknown): string | null {
  if (!error || typeof error !== "object") return null;
  const code = (error as { code?: unknown }).code;
  return typeof code === "string" ? code : null;
}
